const translations = {
    save: 'Save Controller',
    saveError: 'Something went wrong. Please try again.',
    title: 'Edit Controller'
};

export default translations;
